import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Text } from "@/components/typography";
import styles from "./ui.module.css";

export type EmptyReason = "none" | "filters" | "scope" | "complete";

const reasonCopy: Record<EmptyReason, string> = {
  none: "No records exist yet.",
  filters: "No records match the current filters.",
  scope: "No records are visible in the current authorized scope.",
  complete: "All work in this queue is complete.",
};

export interface EmptyStateProps {
  title?: ReactNode;
  description?: ReactNode;
  reason?: EmptyReason;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  title = "Nothing to show",
  description,
  reason = "none",
  action,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn(styles.empty, className)} role="status">
      <Text role="title" as="h3">
        {title}
      </Text>
      <Text role="body" color="secondary" as="p">
        {description ?? reasonCopy[reason]}
      </Text>
      {action}
    </div>
  );
}
